(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './ktor-ktor-http.js', './kotlinx-coroutines-core.js', './ktor-ktor-io.js', './kotlinx-io-kotlinx-io-core.js', './ktor-ktor-serialization.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./ktor-ktor-http.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-io.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./ktor-ktor-serialization.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    if (typeof globalThis['ktor-ktor-serialization'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization-kotlinx'. Its dependency 'ktor-ktor-serialization' was not found. Please, check whether 'ktor-ktor-serialization' is loaded prior to 'ktor-ktor-serialization-kotlinx'.");
    }
    globalThis['ktor-ktor-serialization-kotlinx'] = factory(typeof globalThis['ktor-ktor-serialization-kotlinx'] === 'undefined' ? {} : globalThis['ktor-ktor-serialization-kotlinx'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['ktor-ktor-http'], globalThis['kotlinx-coroutines-core'], globalThis['ktor-ktor-io'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['ktor-ktor-serialization']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_io, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_io_ktor_ktor_serialization) {
  'use strict';
  //region block: imports
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var protoOf = kotlin_kotlin.$_$.eh;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var VOID = kotlin_kotlin.$_$.d;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.k;
  var BinaryFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r2;
  var withCharsetIfNeeded = kotlin_io_ktor_ktor_http.$_$.e2;
  var TextContent = kotlin_io_ktor_ktor_http.$_$.u;
  var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z2;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q1;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t1;
  var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x2;
  var readRemaining = kotlin_io_ktor_ktor_io.$_$.k;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.k1;
  var discard = kotlin_io_ktor_ktor_io.$_$.y;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var readText = kotlin_io_ktor_ktor_io.$_$.z;
  var JsonConvertException = kotlin_io_ktor_ktor_serialization.$_$.d;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var serializerOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c3;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e3;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var KtMap = kotlin_kotlin.$_$.g7;
  var SetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var KtSet = kotlin_kotlin.$_$.n7;
  var firstOrNull_0 = kotlin_kotlin.$_$.n9;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.y2;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var isArray = kotlin_kotlin.$_$.jg;
  var KtList = kotlin_kotlin.$_$.e7;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var Exception = kotlin_kotlin.$_$.gn;
  var joinToString = kotlin_kotlin.$_$.aa;
  var to = kotlin_kotlin.$_$.ip;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var filterNotNull = kotlin_kotlin.$_$.j9;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var singleOrNull = kotlin_kotlin.$_$.tb;
  var Collection = kotlin_kotlin.$_$.y6;
  var KClass = kotlin_kotlin.$_$.ui;
  var emptyList = kotlin_kotlin.$_$.c9;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(KotlinxSerializationConverter$serialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(KotlinxSerializationConverter$serialize$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(KotlinxSerializationConverter$serialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($serializeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deserializeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(KotlinxSerializationConverter, 'KotlinxSerializationConverter', VOID, VOID, VOID, [4, 3]);
  initMetadataForClass(KotlinxWebsocketSerializationConverter, 'KotlinxWebsocketSerializationConverter', VOID, VOID, VOID, [3]);
  //endregion
  function extensions(format) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_providers();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0_safe_receiver = element.vvc(format);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function serialization(_this__u8e3s4, contentType, format) {
    _this__u8e3s4.xtn(contentType, new KotlinxSerializationConverter(format));
  }
  function KotlinxSerializationConverter$serialize$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    this.evd_1 = $$this$unsafeFlow;
    this.fvd_1 = $contentType;
    this.gvd_1 = $charset;
    this.hvd_1 = $typeInfo;
    this.ivd_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = this.evd_1;
            var tmp2 = this.jvd_1;
            this.kvd_1 = tmp0;
            this.n9_1 = 1;
            suspendResult = tmp2.uvc(this.fvd_1, this.gvd_1, this.hvd_1, this.ivd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.kvd_1.a1v(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).p2k = function (value, completion) {
    var i = new KotlinxSerializationConverter$serialize$o$collect$slambda(this.evd_1, this.fvd_1, this.gvd_1, this.hvd_1, this.ivd_1, completion);
    i.jvd_1 = value;
    return i;
  };
  function KotlinxSerializationConverter$serialize$o$collect$slambda_0($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    var i = new KotlinxSerializationConverter$serialize$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tvd_1 = _this__u8e3s4;
    this.uvd_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.uvd_1;
            this.n9_1 = 1;
            var tmp_0 = KotlinxSerializationConverter$serialize$o$collect$slambda_0($this$unsafeFlow, this.tvd_1.wvd_1, this.tvd_1.xvd_1, this.tvd_1.yvd_1, this.tvd_1.zvd_1, null);
            suspendResult = this.tvd_1.vvd_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function serializeContent($this, serializer, format, value, contentType, charset) {
    var tmp;
    if (isInterface(format, StringFormat)) {
      var content = format.b72(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
      tmp = new TextContent(content, withCharsetIfNeeded(contentType, charset));
    } else {
      if (isInterface(format, BinaryFormat)) {
        var content_0 = format.d72(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
        tmp = new ByteArrayContent(content_0, contentType);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unsupported format ' + toString(format);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.ave_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.ave_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.ave_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function KotlinxSerializationConverter$serialize$$inlined$map$1($this, $contentType, $charset, $typeInfo, $value) {
    this.vvd_1 = $this;
    this.wvd_1 = $contentType;
    this.xvd_1 = $charset;
    this.yvd_1 = $typeInfo;
    this.zvd_1 = $value;
  }
  protoOf(KotlinxSerializationConverter$serialize$$inlined$map$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(KotlinxSerializationConverter$serialize$$inlined$map$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function KotlinxSerializationConverter$serialize$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serialize$slambda).kve = function (it, $completion) {
    var tmp = this.lve(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(KotlinxSerializationConverter$serialize$slambda).ja = function (p1, $completion) {
    return this.kve((p1 == null ? true : p1 instanceof OutgoingContent) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$serialize$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return !(this.jve_1 == null);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serialize$slambda).lve = function (it, completion) {
    var i = new KotlinxSerializationConverter$serialize$slambda(completion);
    i.jve_1 = it;
    return i;
  };
  function KotlinxSerializationConverter$serialize$slambda_0(resultContinuation) {
    var i = new KotlinxSerializationConverter$serialize$slambda(resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.kve(it, $completion);
    }, 1);
  }
  function $serializeCOROUTINE$(_this__u8e3s4, contentType, charset, typeInfo, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uve_1 = _this__u8e3s4;
    this.vve_1 = contentType;
    this.wve_1 = charset;
    this.xve_1 = typeInfo;
    this.yve_1 = value;
  }
  protoOf($serializeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var this_0 = asFlow(this.uve_1.avf_1);
            var tmp_0 = new KotlinxSerializationConverter$serialize$$inlined$map$1(this_0, this.vve_1, this.wve_1, this.xve_1, this.yve_1);
            suspendResult = firstOrNull(tmp_0, KotlinxSerializationConverter$serialize$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var fromExtension = suspendResult;
            if (!(fromExtension == null))
              return fromExtension;
            var tmp_1;
            try {
              tmp_1 = serializerForTypeInfo(this.uve_1.zve_1.c75(), this.xve_1);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof SerializationException) {
                var cause = $p;
                tmp_2 = guessSerializer(this.yve_1, this.uve_1.zve_1.c75());
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            var serializer = tmp_1;
            return serializeContent(this.uve_1, serializer, this.uve_1.zve_1, this.yve_1, this.vve_1, this.wve_1);
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deserializeCOROUTINE$(_this__u8e3s4, charset, typeInfo, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jvf_1 = _this__u8e3s4;
    this.kvf_1 = charset;
    this.lvf_1 = typeInfo;
    this.mvf_1 = content;
  }
  protoOf($deserializeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.n9_1 = 1;
            suspendResult = readRemaining(this.mvf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.nvf_1 = suspendResult;
            this.pvf_1 = this.jvf_1.avf_1.t();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!this.pvf_1.u()) {
              this.n9_1 = 5;
              continue $sm;
            }

            var ext = this.pvf_1.v();
            this.n9_1 = 3;
            suspendResult = ext.nto(this.kvf_1, this.lvf_1, ByteReadChannel(this.nvf_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 2;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.ovf_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            return this.ovf_1;
          case 5:
            var serializer = serializerForTypeInfo(this.jvf_1.zve_1.c75(), this.lvf_1);
            this.o9_1 = 6;
            var tmp1_subject = this.jvf_1.zve_1;
            var tmp_1;
            if (isInterface(tmp1_subject, StringFormat)) {
              tmp_1 = this.jvf_1.zve_1.c72(serializer, readText(this.nvf_1, this.kvf_1));
            } else {
              if (isInterface(tmp1_subject, BinaryFormat)) {
                tmp_1 = this.jvf_1.zve_1.e72(serializer, readByteArray(this.nvf_1));
              } else {
                discard(this.nvf_1);
                var message = 'Unsupported format ' + toString(this.jvf_1.zve_1);
                throw IllegalStateException_init_$Create$(toString(message));
              }
            }

            return tmp_1;
          case 6:
            this.o9_1 = 7;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var cause = this.q9_1;
              throw new JsonConvertException('Illegal input: ' + cause.message, cause);
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function KotlinxSerializationConverter(format) {
    this.zve_1 = format;
    this.avf_1 = extensions(this.zve_1);
    var tmp;
    var tmp_0 = this.zve_1;
    if (isInterface(tmp_0, BinaryFormat)) {
      tmp = true;
    } else {
      var tmp_1 = this.zve_1;
      tmp = isInterface(tmp_1, StringFormat);
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'Only binary and string formats are supported, ' + toString(this.zve_1) + ' is not supported.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(KotlinxSerializationConverter).qvf = function (contentType, charset, typeInfo, value, $completion) {
    var tmp = new $serializeCOROUTINE$(this, contentType, charset, typeInfo, value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(KotlinxSerializationConverter).uvc = function (contentType, charset, typeInfo, value, $completion) {
    return this.qvf(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).nto = function (charset, typeInfo, content, $completion) {
    var tmp = new $deserializeCOROUTINE$(this, charset, typeInfo, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function KotlinxWebsocketSerializationConverter(format) {
    this.rvf_1 = format;
    var tmp;
    var tmp_0 = this.rvf_1;
    if (isInterface(tmp_0, BinaryFormat)) {
      tmp = true;
    } else {
      var tmp_1 = this.rvf_1;
      tmp = isInterface(tmp_1, StringFormat);
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'Only binary and string formats are supported, ' + (toString(this.rvf_1) + ' is not supported.');
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  function serializerForTypeInfo(_this__u8e3s4, typeInfo) {
    var module_0 = _this__u8e3s4;
    var tmp0_safe_receiver = typeInfo.csu_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if (tmp0_safe_receiver.k().r()) {
        tmp_0 = null;
      } else {
        var tmp0_elvis_lhs = serializerOrNull(module_0, tmp0_safe_receiver);
        tmp_0 = tmp0_elvis_lhs == null ? checkTypeParameters(tmp0_safe_receiver, typeInfo, module_0) : tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = module_0.j72(typeInfo.bsu_1);
      tmp_1 = tmp2_safe_receiver == null ? null : maybeNullable(tmp2_safe_receiver, typeInfo);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_1;
    return tmp3_elvis_lhs == null ? maybeNullable(serializer(typeInfo.bsu_1), typeInfo) : tmp3_elvis_lhs;
  }
  function guessSerializer(value, module_0) {
    var tmp;
    if (value == null) {
      tmp = get_nullable(serializer_0(StringCompanionObject_instance));
    } else {
      if (isInterface(value, KtList)) {
        tmp = ListSerializer(elementSerializer(value, module_0));
      } else {
        if (isArray(value)) {
          var tmp1_safe_receiver = firstOrNull_0(value);
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = guessSerializer(tmp1_safe_receiver, module_0);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_0(StringCompanionObject_instance)) : tmp2_elvis_lhs;
        } else {
          if (isInterface(value, KtSet)) {
            tmp = SetSerializer(elementSerializer(value, module_0));
          } else {
            if (isInterface(value, KtMap)) {
              var keySerializer = elementSerializer(value.x2(), module_0);
              var valueSerializer = elementSerializer(value.y2(), module_0);
              tmp = MapSerializer(keySerializer, valueSerializer);
            } else {
              var tmp3_elvis_lhs = module_0.j72(getKClassFromExpression(value));
              tmp = tmp3_elvis_lhs == null ? serializer(getKClassFromExpression(value)) : tmp3_elvis_lhs;
            }
          }
        }
      }
    }
    var tmp_1 = tmp;
    return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
  }
  function checkTypeParameters(type, typeInfo, module_0) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = type.k();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp;
      try {
        var tmp0_safe_receiver = element.nn_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (serializerOrNull(module_0, tmp0_safe_receiver) == null) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Exception) {
          var _unused_var__etf5q3 = $p;
          return null;
        } else {
          throw $p;
        }
      }
      if (tmp == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp);
      }
    }
    var nonSerializableArgs = destination;
    if (nonSerializableArgs.r())
      return null;
    var argNames = joinToString(nonSerializableArgs, VOID, VOID, VOID, VOID, VOID, checkTypeParameters$lambda);
    var tmp_3;
    if (nonSerializableArgs.n1() === 1) {
      tmp_3 = to('', 'is');
    } else {
      tmp_3 = to('s', 'are');
    }
    var _destruct__k2r9zo = tmp_3;
    var s = _destruct__k2r9zo.zh();
    var be = _destruct__k2r9zo.ai();
    throw SerializationException_init_$Create$('Serializer for type argument' + s + ' ' + argNames + ' ' + be + " not found for '" + typeInfo.bsu_1.o() + "'. " + ('Ensure that the listed type' + s + ' ' + be + " marked as '@Serializable'."));
  }
  function maybeNullable(_this__u8e3s4, typeInfo) {
    var tmp;
    var tmp0_safe_receiver = typeInfo.csu_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l()) === true) {
      tmp = get_nullable(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function elementSerializer(_this__u8e3s4, module_0) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = filterNotNull(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = guessSerializer(item, module_0);
      destination.j1(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var e = _iterator__ex2g4s_0.v();
      var key = e.y70().z71();
      if (set.j1(key)) {
        list.j1(e);
      }
    }
    var serializers = list;
    if (serializers.n1() > 1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
      var _iterator__ex2g4s_1 = serializers.t();
      while (_iterator__ex2g4s_1.u()) {
        var item_0 = _iterator__ex2g4s_1.v();
        var tmp$ret$7 = item_0.y70().z71();
        destination_0.j1(tmp$ret$7);
      }
      // Inline function 'kotlin.error' call
      var message = 'Serializing collections of different element types is not yet supported. ' + ('Selected serializers: ' + toString(destination_0));
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp0_elvis_lhs = singleOrNull(serializers);
    var selected = tmp0_elvis_lhs == null ? serializer_0(StringCompanionObject_instance) : tmp0_elvis_lhs;
    if (selected.y70().n72()) {
      return selected;
    }
    if (!isInterface(selected, KSerializer))
      THROW_CCE();
    var tmp$ret$9;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$9 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_2 = _this__u8e3s4.t();
      while (_iterator__ex2g4s_2.u()) {
        var element = _iterator__ex2g4s_2.v();
        if (element == null) {
          tmp$ret$9 = true;
          break $l$block_0;
        }
      }
      tmp$ret$9 = false;
    }
    if (tmp$ret$9) {
      return get_nullable(selected);
    }
    return selected;
  }
  function checkTypeParameters$lambda(it) {
    var clz = it.j();
    var tmp;
    if (!(clz == null) ? isInterface(clz, KClass) : false) {
      tmp = "'" + clz.o() + "'";
    } else {
      tmp = "'" + toString(it) + "'";
    }
    return tmp;
  }
  function get_providers() {
    return emptyList();
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = KotlinxWebsocketSerializationConverter;
  _.$_$.b = serialization;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-serialization-kotlinx.js.map
